import { Component, OnInit, Input } from '@angular/core';
import { FilterService } from '../filter.service';

@Component({
  selector: 'app-rating-tag-filter',
  templateUrl: './rating-tag-filter.component.html',
  styleUrls: ['./rating-tag-filter.component.css']
})
export class RatingTagFilterComponent implements OnInit {
  @Input() ratingTag;
  @Input() withSubtags: boolean;

  label: string;
  id: string;
  subtags = [];

  constructor(
    private fs: FilterService,
  ) { }

  ngOnInit() {
    const tpl = this.ratingTag[0].split('|').map(x => x.trim());
    this.id = tpl[0];
    this.label = tpl[1];
    this.subtags = this.ratingTag[1].map(x => x.split('|'));
  }

  switch(event) {
    if (event.ctrlKey) {
      this.fs.setExcludeRatingTagFilter(this.id);
    } else {
      this.fs.setRatingTagFilter(this.id, this.subtags.map(x => x[0]));
    }
  }

  switchSubtag(id, event) {
    if (event.ctrlKey) {
      this.fs.setExcludeRatingTagFilter(id);
    } else {
      this.fs.setRatingTagFilter(id);
    }
  }

  get isSelected() {
    return this.fs.isSelectedRatingTag(this.id);
  }

  get isExcluded() {
    return this.fs.isExcludedRatingTag(this.id);
  }

  isSubtagSelected(id) {
    return this.fs.isSelectedRatingTag(id);
  }

  isSubtagExcluded(id) {
    return this.fs.isExcludedRatingTag(id);
  }

  get showSubtags() {
    return this.withSubtags && this.isSelected;
  }


}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/rating-tag-filter/rating-tag-filter.component.ts